import difference from '@turf/difference'
import GeoJSONFormat from 'ol/format/geojson'

const GeoJSONParser = new GeoJSONFormat

export default (p1, p2, projection) => {
  let poly1 = p1.clone()
  let poly2 = p2.clone()

  poly1.getGeometry().transform(projection, 'EPSG:4326')
  poly2.getGeometry().transform(projection, 'EPSG:4326')

  poly1 = GeoJSONParser.writeFeatureObject(poly1)
  poly2 = GeoJSONParser.writeFeatureObject(poly2)

  const diff = difference(poly1, poly2)

  if (!diff) {
    return
  }

  const featureErased = GeoJSONParser.readFeature(diff, {
    dataProjection: 'EPSG:4326',
    featureProjection: projection
  })

  return featureErased
}


// WEBPACK FOOTER //
// ./src/components/core/utils/feature-difference.js